// src/api/bookmark.network.ts
import { http } from './http.ts';
import { ENDPOINTS } from './endpoints.ts';

export const BookmarkNetwork = {
  syncBookmarks: () =>
    http.get(ENDPOINTS.dashboard.syncBookmarks),

  getBookmarkList: (page: number, perPage: number) =>
    http.get(ENDPOINTS.service.bookmarks, { params: { page, per_page: perPage } }),

  toggleBookmark: (uuid: string) =>
    http.post(ENDPOINTS.service.toggleBookmark(uuid)),
};
